import { C } from "../styles/theme";

export default function NotFound() {
  return (
    <div style={{ padding: 52, textAlign: "center", color: C.gray, background: C.bg, minHeight: "40vh" }}>
      Page not found.
    </div>
  );
}
